var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.companies},on:{"change":_vm.switchCompany},model:{value:(_vm.currentCompanyId),callback:function ($$v) {_vm.currentCompanyId=$$v},expression:"currentCompanyId"}})}
var staticRenderFns = []

export { render, staticRenderFns }